import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../App";

let _rate = null;
let _fetching = null;

function fetchRate() {
  if (_rate) return Promise.resolve(_rate);
  if (!_fetching) {
    _fetching = api
      .get("/fx/usd-mxn")
      .then((r) => {
        _rate = r.data?.mxn_per_usd || null;
        return _rate;
      })
      .catch(() => null);
  }
  return _fetching;
}

export function useUsdRate() {
  const [rate, setRate] = useState(_rate);
  useEffect(() => {
    if (!_rate) fetchRate().then(setRate);
  }, []);
  return rate;
}

/**
 * "≈ $X USD" hint next to an MXN price. Only shown when the UI language is
 * English (US/foreign visitors) and the FX rate is available.
 */
export default function UsdHint({ amountMxn, className = "" }) {
  const { i18n } = useTranslation();
  const rate = useUsdRate();
  if (!i18n.language?.startsWith("en") || !rate || !amountMxn) return null;
  const usd = amountMxn / rate;
  const label = usd >= 100 ? Math.round(usd).toLocaleString() : usd.toFixed(usd < 10 ? 2 : 0);
  return (
    <span
      className={`text-xs text-neutral-400 font-normal whitespace-nowrap ${className}`}
      data-testid="usd-hint"
    >
      ≈ ${label} USD
    </span>
  );
}
